import { Children, cloneElement, forwardRef } from 'react';
import { PolymorphicRef } from '@mofid-securities/uikit';
import { classnames } from '@/utils/classnames';
import {
  ISelectButtonGroupProps,
  TSelectButtonGroupChild,
  TSelectButtonValue,
} from './SelectButton.types';

export const SelectButtonGroup = forwardRef(
  <TValue extends TSelectButtonValue = TSelectButtonValue>(
    {
      children,
      selectedValue,
      onChange,
      className,
      variant = 'secondary',
    }: ISelectButtonGroupProps<TValue>,
    forwardedRef: PolymorphicRef<'div'>
  ) => {
    const handleClick = (event: TButtonEvent) => {
      const value = (event?.currentTarget?.value || undefined) as TValue;
      onChange(value);
    };

    return (
      <div
        ref={forwardedRef}
        className={classnames(
          'flex rounded-md',
          variant === 'primary' && 'gap-x-2 bg-[#F3FBFF] px-3 py-1',
          className
        )}
      >
        {Children.map(
          Children.toArray(children) as any,
          (SelectButtonChild: TSelectButtonGroupChild<TValue>) => {
            const { props } = SelectButtonChild;
            const isSelected: boolean = selectedValue === props.value;
            return cloneElement(SelectButtonChild, {
              ...props,
              key: props.value,
              isSelected,
              groupVariant: variant,
              onClick: handleClick,
            });
          }
        )}
      </div>
    );
  }
) as <TValue extends TSelectButtonValue = TSelectButtonValue>(
  __props: ISelectButtonGroupProps<TValue> & { ref?: PolymorphicRef<'div'> }
) => JSX.Element;

// @ts-ignore
SelectButtonGroup.displayName = 'SelectButtonGroup';
